/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPumpTriangleDown: {
  name: 'pump-triangle-down';
  data: string;
} = {
  name: 'pump-triangle-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 2a2 2 0 0 0-2 2v4h-3V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2v2H2a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2h-5v-2h2a2 2 0 0 0 2-2v-2h3v1a1 1 0 1 0 2 0V4h2v11a1 1 0 1 0 2 0V4a2 2 0 0 0-2-2h-2ZM7 20v-2h1v2H7Zm2-4H3v-2h9v2H9Zm-6-4h9v-2H3v2Zm14 0h-3v-2h3v2Zm-5-4V6H3v2h9Zm6.08 10h3.84a1 1 0 0 1 .78 1.625l-1.92 2.399a1 1 0 0 1-1.56 0l-1.92-2.4A1 1 0 0 1 18.08 18Z" fill="currentColor"/></svg>`,
};
